export default [
    {
        name: "mdmId",
        label: "MDM ID",
        type: "number",
    },
    {
        name: "driverId",
        label: "Driver",
        type: "list",
        helpText: "Driver",
        url: "/drivers",
        filterValue: "name",
        isMultiple: false,
        entityName: "driver",
        include: true,
    },
];
